<template>
  <div class="personal">
    <div class="header">
      <div class="upload">
        <van-uploader
          v-model="uploader"
          :after-read="_afterRead"
          :max-count="1"
        >
          <div v-show="personalForm.avatar ? false : true">
            <van-button
              icon="plus"
              size="small"
              style="
                border-radius: 20px;
                background: none;
                border-color: rgb(255, 255, 255, 0.5);
                color: #fff;
              "
              >上传头像</van-button
            >
          </div>
          <div class="aside" v-if="personalForm.avatar">
            <img
              style="width: 80px; height: 80px; border-radius: 50%"
              :src="miXinGetImgUrl(personalForm.avatar)"
              alt
            />
          </div>
        </van-uploader>
      </div>
    </div>
    <van-form
      @submit="onSubmit"
      :model="personalForm"
      ref="personalForm"
      style="padding: 0px 25px"
    >
      <van-field
        style="font-size: 16px; margin-top: 10px"
        v-model="personalForm.nickName"
        placeholder="请输入用户姓名"
        :left-icon="mobileUser"
        :rules="[{ required: true, message: '' }]"
      />
      <van-field
        style="font-size: 16px; margin-top: 10px"
        v-model="personalForm.age"
        label=""
        type="digit"
        placeholder="请输入用户年龄"
        :left-icon="mobileAge"
        :rules="[
          {
            validator: validatorAge,
            required: true,
            message: '年龄范围为16-60',
          },
        ]"
      />
      <van-field
        style="font-size: 16px; margin-top: 10px"
        readonly
        clickable
        name="picker"
        v-model="personalForm.sex"
        label=""
        placeholder="请选择性别"
        :left-icon="mobileGender"
        @click="showSex = true"
        :rules="[{ required: true, message: '' }]"
      />
      <van-popup v-model="showSex" position="bottom">
        <van-picker
          show-toolbar
          :columns="sexOptions"
          @confirm="sexConfirm"
          @cancel="showSex = false"
        />
      </van-popup>
      <!-- <van-field
        style="font-size:16px;"
        readonly
        clickable
        name="picker"
        v-model="personalForm.focusArea"
        label="关心领域"
        placeholder="请选择关心领域"
        @click="showFocusArea = true"
        :rules="[{ required: true, message: '请选择关心领域' }]"
      />
      <van-popup v-model="showFocusArea" position="bottom">
        <van-picker
          show-toolbar
          :columns="areaOptions"
          @confirm="areaConfirm"
          @cancel="showFocusArea = false"
        />
      </van-popup> -->
      <van-field
        style="font-size: 16px; margin-top: 10px"
        readonly
        clickable
        name="picker"
        v-model="personalForm.culture"
        placeholder="请选择文化程度"
        :left-icon="mobileCulture"
        @click="showEducationBackground = true"
        :rules="[{ required: true, message: '' }]"
      />
      <van-popup v-model="showEducationBackground" position="bottom">
        <van-picker
          show-toolbar
          :columns="typeOptions"
          @confirm="typeConfirm"
          @cancel="showEducationBackground = false"
        />
      </van-popup>
      <!-- <van-field
        style="font-size: 16px; margin-top: 10px"
        v-model="personalForm.profession"
        label=""
        placeholder="请输入职业"
        :left-icon="mobileJob"
        :rules="[{ required: true, message: '' }]"
      /> -->
      <van-field
        style="font-size: 16px; margin-top: 10px"
        readonly
        clickable
        name="picker"
        v-model="personalForm.industry"
        placeholder="请选择所属行业"
        :left-icon="mobileIndustry"
        @click="showIndustryInvolved = true"
        :rules="[{ required: true, message: '' }]"
      />
      <van-popup v-model="showIndustryInvolved" position="bottom">
        <van-picker
          show-toolbar
          :columns="industryOptions"
          @confirm="industryConfirm"
          @cancel="showIndustryInvolved = false"
        />
      </van-popup>

      <treeselect
        style="font-size: 16px; margin-top: 40px"
        v-model="personalForm.deptId"
        :options="deptOptions"
        :show-count="true"
        :maxHeight="500"
        @open="open"
        placeholder="请选择所属单位"
      />

      <div style="margin: 40px 30px">
        <van-button class="save" block native-type="submit">保存</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { getUserInfo, phoneEdit } from "../../api/user";
import { uploadImages } from "../../api/user";
import Exif from "exif-js";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { treeselectAll } from "../../api/user";
import { getDicts } from "../../api/user";
import { Toast } from "vant";
import mobileUser from "../../assets/Login/user.png";
import mobileAge from "../../assets/Login/age.png";
import mobilePassword from "../../assets/Login/password.png";
import mobilePhone from "../../assets/Login/phone.png";
import mobileCard from "../../assets/Login/card.png";
import mobileJob from "../../assets/Login/job.png";
import mobileGender from "../../assets/Login/gender.png";
import mobileIndustry from "../../assets/Login/industry.png";
import mobileCulture from "../../assets/Login/culture.png";

export default {
  name: "personal",
  components: { Treeselect },
  data() {
    return {
      id: null, //用户id
      defaultPhoneHeight: "", //屏幕默认高度
      nowPhoneHeight: "", //屏幕现在高度
      uploader: [],
      type: "",
      mobileUser,
      mobileAge,
      mobilePassword,
      mobilePhone,
      mobileCard,
      mobileJob,
      mobileGender,
      mobileIndustry,
      mobileCulture,
      token: "",
      userName: "",
      personalForm: {
        nickName: "", //用户昵称
        age: "",
        sex: "",
        cardNumber: "",
        profession: "", //职业

        culture: "",
        industry: "",

        gender: "", //性别
        industryInvolved: "", //所属行业
        educationBackground: "", //文化程度
        deptId: "", //所属工会
        avatar: "", //头像
        imgUrl: "",
        // roleIds: [4],
      },
      // 图片信息
      files: {
        name: "",
        type: "",
      },
      deptOptions: [], //所属行业
      showDeptId: false, //默认不显示所属单位遮罩层
      sexOptions: [], //性别
      showSex: false, //默认不显示性别遮罩层
      areaOptions: [], //关心领域
      showFocusArea: false, //默认不显示关注领域遮罩层
      industryOptions: [], //所属行业
      showIndustryInvolved: false, //默认不显示所属行业遮罩层
      typeOptions: [], //文化程度
      showEducationBackground: false, //默认不显示所属行业遮罩层
    };
  },
  watch: {
    nowPhoneHeight: function () {
      if (this.defaultPhoneHeight != this.nowPhoneHeight) {
        //手机键盘打开
      } else {
        //手机键盘关闭
        this.open();
      }
    },
    "personalForm.sex": function (val) {
      if (val == "男") {
        this.personalForm.gender = "0";
      } else if (val == "女") {
        this.personalForm.gender = "1";
      }
    },
  },
  methods: {
    validatorAge(val) {
      if (val < 16 || val > 60) {
        return false;
      }
    },
    open() {},
    // 上传图片
    _afterRead(file) {
      this.files.name = file.file.name; // 获取文件名
      this.files.type = file.file.type; // 获取类型
      this.imgPreview(file.file);
    },
    // 处理图片
    imgPreview(file) {
      let self = this;
      let Orientation;
      // 去获取拍照时的信息，解决拍出来的照片旋转问题   npm install exif-js --save   这里需要安装一下包
      Exif.getData(file, function () {
        Orientation = Exif.getTag(this, "Orientation");
      });
      // 看支持不支持FileReader
      if (!file || !window.FileReader) return;
      if (/^image/.test(file.type)) {
        // 创建一个reader
        let reader = new FileReader();
        // 将图片2将转成 base64 格式
        reader.readAsDataURL(file);
        // 读取成功后的回调
        reader.onloadend = function () {
          let result = this.result;
          let img = new Image();
          img.src = result;
          //判断图片是否大于500K,是就直接上传，反之压缩图片
          if (result.length <= 500 * 1024) {
            // 上传图片
            self.postImg(result);
          } else {
            img.onload = function () {
              let data = self.compress(img, Orientation);
              // 上传图片
              self.postImg(data);
            };
          }
        };
      }
    },
    // 压缩图片
    compress(img, Orientation) {
      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext("2d");
      //瓦片canvas
      let tCanvas = document.createElement("canvas");
      let tctx = tCanvas.getContext("2d");
      let initSize = img.src.length;
      let width = img.width;
      let height = img.height;
      //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
      let ratio;
      if ((ratio = (width * height) / 4000000) > 1) {
        ratio = Math.sqrt(ratio);
        width /= ratio;
        height /= ratio;
      } else {
        ratio = 1;
      }
      canvas.width = width;
      canvas.height = height;
      //    铺底色
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      //如果图片像素大于100万则使用瓦片绘制
      let count;
      if ((count = (width * height) / 1000000) > 1) {
        count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
        //      计算每块瓦片的宽和高
        let nw = ~~(width / count);
        let nh = ~~(height / count);
        tCanvas.width = nw;
        tCanvas.height = nh;
        for (let i = 0; i < count; i++) {
          for (let j = 0; j < count; j++) {
            tctx.drawImage(
              img,
              i * nw * ratio,
              j * nh * ratio,
              nw * ratio,
              nh * ratio,
              0,
              0,
              nw,
              nh
            );
            ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
          }
        }
      } else {
        ctx.drawImage(img, 0, 0, width, height);
      }
      //修复ios上传图片的时候 被旋转的问题
      if (Orientation != "" && Orientation != 1) {
        switch (Orientation) {
          case 6: //需要顺时针（向左）90度旋转
            this.rotateImg(img, "left", canvas);
            break;
          case 8: //需要逆时针（向右）90度旋转
            this.rotateImg(img, "right", canvas);
            break;
          case 3: //需要180度旋转
            this.rotateImg(img, "right", canvas); //转两次
            this.rotateImg(img, "right", canvas);
            break;
        }
      }
      //进行最小压缩
      let ndata = canvas.toDataURL("image/jpeg", 0.1);
      tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
      return ndata;
    },
    // 旋转图片
    rotateImg(img, direction, canvas) {
      //最小与最大旋转方向，图片旋转4次后回到原方向
      const min_step = 0;
      const max_step = 3;
      if (img == null) return;
      //img的高度和宽度不能在img元素隐藏后获取，否则会出错
      let height = img.height;
      let width = img.width;
      let step = 2;
      if (step == null) {
        step = min_step;
      }
      if (direction == "right") {
        step++;
        //旋转到原位置，即超过最大值
        step > max_step && (step = min_step);
      } else {
        step--;
        step < min_step && (step = max_step);
      }
      //旋转角度以弧度值为参数
      let degree = (step * 90 * Math.PI) / 180;
      let ctx = canvas.getContext("2d");
      switch (step) {
        case 0:
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0);
          break;
        case 1:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, 0, -height);
          break;
        case 2:
          canvas.width = width;
          canvas.height = height;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, -height);
          break;
        case 3:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, 0);
          break;
      }
    },
    //将base64转换为文件
    dataURLtoFile(dataurl) {
      var arr = dataurl.split(","),
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], this.files.name, {
        type: this.files.type,
      });
    },
    // 提交图片到后端
    postImg(base64) {
      let file = this.dataURLtoFile(base64); // 图片
      file.status = "uploading";
      file.message = "上传中...";
      var formData = new window.FormData();
      formData.append("file", file);
      uploadImages(formData).then((res) => {
        if (res.code === 200) {
          this.personalForm.avatar = res.data;
          file.status = "success";
          file.message = "上传成功";
        } else {
          setTimeout(() => {
            file.status = "failed";
            file.message = "上传失败";
          }, 1000);
        }
      });
    },
    // 保存
    onSubmit() {
      if (
        this.personalForm.deptId == null ||
        this.personalForm.deptId == "" ||
        this.personalForm.deptId == undefined
      ) {
        Toast.fail("请选择所属单位");
        return;
      }
      this.personalForm.userName = localStorage.getItem("userName")
      this.personalForm.userId = this.id
      phoneEdit(this.personalForm).then((response) => {
        if (response.code == 200) {
          Toast.success("保存成功");
          window.localStorage.setItem(
            "userName",
            this.personalForm.userName
          );
          this.miniJump(`me`, 'isBack')
        } else {
          Toast.fail("请重试");
        }
      });
    },
    // 手机号码校验
    validatorPhonenumber(val) {
      return /(^[1][3,4,5,7,8,9][0-9]{9}$)/.test(val);
    },
    getBack() {
      this.miniJump(`me`, 'isBack')
    },
    getToken() {
      this.token = window.localStorage.getItem("user");
    },
    getInfo() {
      this.userName = typeof Number(window.localStorage.getItem("userName")) === Number ?
      window.localStorage.getItem("userName") :
      window.localStorage.getItem("userName").replace(/\"/g, "");
      if (this.token) {
        getUserInfo({ userName: this.userName }).then((response) => {
          this.personalForm = response.data;
          this.personalForm.sex = response.data.sex;
          this.personalForm.industry = response.data.industryInvolved;
          this.personalForm.industryInvolved = undefined;
          this.personalForm.culture = response.data.educationBackground;
          this.personalForm.educationBackground = undefined;
        });
      }
    },
    deptConfirm(value) {
      this.personalForm.deptId = value;
      this.showDeptId = false;
    },
    sexConfirm(value, index) {
      this.personalForm.sex = value;
      this.personalForm.gender = index;
      this.showSex = false;
    },
    industryConfirm(value, index) {
      this.personalForm.industry = value;
      this.personalForm.industryInvolved = index;
      this.showIndustryInvolved = false;
    },
    typeConfirm(value, index) {
      this.personalForm.culture = value;
      this.personalForm.educationBackground = index;
      this.showEducationBackground = false;
    },
    /** 查询单位下拉树结构 */
    getTreeselect() {
      treeselectAll({userId:this.id}).then((response) => {
        this.deptOptions = response.data;
      });
    },
    cancel() {
      this.miniJump(`/mine`)
    },
  },
  created() {
    this.id = localStorage.getItem("userId");

    this.getToken();
    this.getInfo();
    this.type = this.$route.params.type;
    this.getTreeselect();
    //性别字典
    getDicts("sys_user_sex").then((response) => {
      this.sexOptions = response.data.map((item) => {
        return item.dictLabel;
      });
    });
    //关心领域字典
    getDicts("focus_area").then((response) => {
      this.areaOptions = response.data.map((item) => {
        return item.dictLabel;
      });
    });
    //所属行业字典
    getDicts("unit_industry").then((response) => {
      this.industryOptions = response.data.map((item) => {
        return item.dictLabel;
      });
    });
    //文化程度字典
    getDicts("education_type").then((response) => {
      this.typeOptions = response.data.map((item) => {
        return item.dictLabel;
      });
    });
  },
  mounted() {
    this.defaultPhoneHeight = window.innerHeight;
    window.onresize = () => {
      this.nowPhoneHeight = window.innerHeight;
    };
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>

<style lang="scss" scoped>
.personal {
  background: rgba(236, 239, 246, 0.2);
  .header {
    background: rgb(81, 100, 221);
    width: 100%;
    height: 80px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 0 0 50px 0;
    .aside {
      display: flex;
      margin: 10px 20px;
    }
    .upload {
      margin: 0 20px;
    }
  }
}
.van-form {
  margin-top: 30px;
  overflow-x: hidden;
}
.van-field {
  overflow-x: hidden;
}
.save {
  background: rgb(236, 239, 246);
  border-color: rgb(70, 90, 217);
  color: rgb(70, 90, 217);
  border-radius: 30px;
  font-size: 16px;
  font-weight: 600;
  height: 50px;
}
.cancel {
  border-color: #e42e4f;
  color: #e42e4f;
  background: rgb(236, 239, 246);
  border-radius: 30px;
  font-size: 16px;
  font-weight: 600;
  margin: 10px 0;
  height: 50px;
}
</style>

<style lang="scss">
.vue-treeselect__control {
  border: none;
  border-bottom: 1px solid rgb(235, 237, 240);
}
.vue-treeselect__control-arrow {
  width: 15px;
  height: 15px;
}
.van-field__control--custom {
  height: 35px;
}
</style>
